import { ROUTES } from "../../../config/routes";
import { WidgetDefinition } from "./types";
import ChannelCheckupCard from "./cards/secondary/ChannelCheckupCard";
import MusicAssetsCard from "./cards/secondary/MusicAssetsCard";
import MusicDsrCard from "./cards/secondary/MusicDsrCard";
import ClaimPolicyCard from "./cards/secondary/ClaimPolicyCard";
import CompositionAssetsCard from "./cards/secondary/CompositionAssetsCard";
import ScrapersCard from "./cards/secondary/ScrapersCard";
import ClassifiersCard from "./cards/secondary/ClassifiersCard";
import OacAuditCard from "./cards/secondary/OacAuditCard";
import AdminUsersCard from "./cards/secondary/AdminUsersCard";
import { makeLinkTile } from "./cards/secondary/LinkTileCard";

/** Tool summary cards shown after the priority cards, in their default order. */
export const SECONDARY_WIDGETS: WidgetDefinition[] = [
  {
    id: "channel-checkup",
    title: "Channel Checkup",
    description: "Upload and schedule gaps across channels",
    icon: "pi pi-heart",
    accent: "#e54666",
    path: ROUTES.CHANNEL_CHECKUP,
    requiredTool: "ChannelCheckup",
    supportsScope: true,
    mineLabel: "My channels",
    filterFields: [
      {
        key: "includeInactive",
        type: "toggle",
        label: "Include paused / inactive channels",
        help: "Count paused and inactive channels in the totals",
      },
    ],
    defaultFilters: { includeInactive: false },
    Component: ChannelCheckupCard,
  },
  {
    id: "music-assets",
    title: "YouTube Music Assets",
    description: "Open issues across music asset audits",
    icon: "pi pi-youtube",
    accent: "#d6409f",
    path: ROUTES.YOUTUBE_MUSIC_ASSET_AUDITS_DASHBOARD,
    requiredTool: "DataHealthTool",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: MusicAssetsCard,
  },
  {
    id: "music-dsr",
    title: "Music DSR",
    description: "DSR report freshness and review queues",
    icon: "pi pi-file-edit",
    accent: "#3e63dd",
    path: ROUTES.DSR_AUDITS,
    requiredTool: "DataHealthTool",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: MusicDsrCard,
  },
  {
    id: "claim-policy",
    title: "Claim Policy Patch",
    description: "Claims and videos patched recently",
    icon: "pi pi-chart-line",
    accent: "#12a594",
    path: ROUTES.CLAIM_POLICY_PATCH_DASHBOARD_OVERVIEW,
    requiredTool: "DataHealthTool",
    supportsScope: false,
    filterFields: [
      {
        key: "windowDays",
        type: "select",
        label: "Window",
        options: [
          { label: "Last 7 days", value: "7" },
          { label: "Last 30 days", value: "30" },
          { label: "Last 90 days", value: "90" },
        ],
      },
    ],
    defaultFilters: { windowDays: "30" },
    Component: ClaimPolicyCard,
  },
  {
    id: "composition-assets",
    title: "Composition Assets",
    description: "Composition metadata discrepancies",
    icon: "pi pi-volume-up",
    accent: "#6e56cf",
    path: ROUTES.COMPOSITION_METADATA_AUDIT_COMPARER,
    requiredTool: "DataHealthTool",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: CompositionAssetsCard,
  },
  {
    id: "scrapers",
    title: "Music Asset Scraper",
    description: "Scrape jobs running, failed and completed",
    icon: "pi pi-search",
    accent: "#0d74ce",
    path: ROUTES.MUSIC_ASSET_SCRAPER,
    requiredTool: "DataHealthTool",
    supportsScope: true,
    mineLabel: "My jobs",
    filterFields: [],
    defaultFilters: {},
    Component: ScrapersCard,
  },
  {
    id: "classifiers",
    title: "Classifiers",
    description: "Recent music classifier and quality audit runs",
    icon: "pi pi-th-large",
    accent: "#ab6400",
    path: ROUTES.CLASSIFIERS_MUSIC_CLASSIFIER_HISTORY,
    requiredTool: "Classifiers",
    supportsScope: true,
    mineLabel: "My runs",
    filterFields: [],
    defaultFilters: {},
    Component: ClassifiersCard,
  },
  {
    id: "oac-audit",
    title: "OAC Audit",
    description: "OAC channels without activity this month",
    icon: "pi pi-check-square",
    accent: "#cc4e00",
    path: ROUTES.OAC_AUDIT,
    requiredTool: "OACAudit",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: OacAuditCard,
  },
  {
    id: "admin-users",
    title: "Users & Access",
    description: "Orion users and tool access",
    icon: "pi pi-users",
    accent: "#60646c",
    path: ROUTES.ADMIN_TOOLS,
    requiredRole: "admin",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: AdminUsersCard,
  },
  {
    id: "labels-dashboard",
    title: "Labels Dashboard",
    description: "Label reporting and catalogue overview",
    icon: "pi pi-book",
    accent: "#8d6e2b",
    path: ROUTES.LABELS_DASHBOARD,
    requiredTool: "LabelsDashboard",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: makeLinkTile(ROUTES.LABELS_DASHBOARD),
  },
  {
    id: "spotify-uploader",
    title: "Spotify Podcast Uploader",
    description: "Upload episodes to Spotify podcasts",
    icon: "pi pi-megaphone",
    accent: "#1db954",
    path: ROUTES.SPOTIFY_PODCAST_UPLOADER,
    requiredTool: "spotifyUploader",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: makeLinkTile(ROUTES.SPOTIFY_PODCAST_UPLOADER),
  },
  {
    id: "sound-recordings",
    title: "Sound Recordings",
    description: "Link sound recordings to music videos",
    icon: "pi pi-wrench",
    accent: "#2b9a66",
    path: ROUTES.SOUND_RECORDINGS_LINKING_TOOL,
    requiredTool: "DataHealthTool",
    supportsScope: false,
    filterFields: [],
    defaultFilters: {},
    Component: makeLinkTile(ROUTES.SOUND_RECORDINGS),
  },
];
